enum ConfidentialType {
    NonConfident = 'Non-Confidential',
    Confident = 'Confidential'
}

export default ConfidentialType